export default __webpack_public_path__ + "static/media/restartIcon.ba2931af.svg";